@if (group) {
  <ng-container [formGroup]="group">
    <ng-container *ngTemplateOutlet="radioGroup"></ng-container>
  </ng-container>
}

@if (!group) {
  <ng-container *ngTemplateOutlet="radioGroup"></ng-container>
}

<ng-template #radioGroup>
  <div class="container">
    <div class="label">
      <mat-icon [ngClass]="isStacked ? 'align-start' : ''">{{ icon }}</mat-icon>
      <span class="body2">{{ shouldCapitalizeLabel ? (label | titlecase) : label }}</span>
      @if (info) {
        <!-- a button so keyboard users can reach the info too: Material shows the tooltip on focus, and screen readers read it as the button's description -->
        <button
          type="button"
          class="button-reset info-button"
          [attr.aria-label]="sysText.moreInformation_ariaLabel"
          [matTooltip]="info"
          [matTooltipShowDelay]="500"
          matTooltipPosition="above">
          <mat-icon class="button-icon">info_outline</mat-icon>
        </button>
      }
    </div>
    <div [ngClass]="isStacked ? 'radio-stacked' : 'radio-flat'" class="radio-group">
      <mat-radio-group [attr.aria-label]="label" [formControl]="control" color="accent" (change)="onChange($event)">
        @if (!isYesNo) {
          @for (option of options; track option.id) {
            <mat-radio-button [value]="option.id">{{ option.description | capitalizefirst }}</mat-radio-button>
          }
        } @else {
          <mat-radio-button [value]="true">{{ customYes ? customYes : (sysText.yes | capitalizefirst) }}</mat-radio-button>
          <mat-radio-button [value]="false">{{ customNo ? customNo : (sysText.no | capitalizefirst) }}</mat-radio-button>
        }
        @if (hint) {
          <mat-hint [ngClass]="{ highlight: isHintHighlighted }">
            <span class="hint">
              {{ hint }}
            </span>
          </mat-hint>
        }
        <div aria-live="polite">
          @if (control.errors?.msError) {
            <mat-error class="hint">{{ control.errors?.msError }}</mat-error>
          }
        </div>
      </mat-radio-group>
    </div>
  </div>
</ng-template>
